import { render, staticRenderFns } from "./ConfirmInvitationProvider.vue?vue&type=template&id=58eaa06e&scoped=true&"
import script from "./ConfirmInvitationProvider.vue?vue&type=script&lang=ts&"
export * from "./ConfirmInvitationProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmInvitationProvider.vue?vue&type=style&index=0&id=58eaa06e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eaa06e",
  null
  
)

export default component.exports